import {styled, Typography, TypographyProps} from "@mui/material";

const StyledSpecialityName = styled(Typography)<TypographyProps>(({theme}) => ({
    fontSize: 22,
    fontWeight: 400,
    color: theme.palette.text.primary
}))

export default StyledSpecialityName;
